// extracted by mini-css-extract-plugin
export default {"root":"LoadingModal_root__Veb7m","icon":"LoadingModal_icon__O-f0P","title":"LoadingModal_title__ej1ar","tip":"LoadingModal_tip__jaL3p"};